import React from 'react';

import FundProfileSectionHeader from './FundProfileSectionHeader/fundProfileSectionHeader';
import FundProfileFormModalContainer from 'buyside/components/container/FundProfileShow/FundProfileFormModalContainer';
import AlertStatic from 'buyside/components/presentation/AlertStatic/alertStatic';

import { ALLOCATOR } from 'buyside/util/fundProfileConstants';

export class FundProfileSection extends React.Component {
  constructor() {
    super();
    this.state = { editModalOpen: false, reorderModalOpen: false };
    this.openEditModal = this.openEditModal.bind(this);
    this.openReorderModal = this.openReorderModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openEditModal() {
    this.setState({ editModalOpen: true });
  }

  openReorderModal() {
    this.setState({ reorderModalOpen: true });
  }

  closeModal() {
    this.setState({
      editModalOpen: false,
      reorderModalOpen: false,
      serverError: false
    });
  }

  render() {
    const {
      section,
      roleIsAdmin,
      roleIsCommunity,
      fundProfile,
      icon,
      title,
      tip,
      sectionEmpty,
      emptyText,
      sectionVisibility,
      sectionCompletenessPercent,
      sectionExcluded,
      component: Component,
      editForm,
      editFormBoxText,
      reorderForm,
      reorderFormBoxText,
      validationSchema,
      updateFundProfile,
      createAuditRecord,
      openBlocklistModal,
      showUserDetails,
      shrink,
      fundProfileId
    } = this.props;
    const updateSection = ({ fundProfile }) => updateFundProfile({ fundProfile, section });
    const sectionConfidential = roleIsCommunity && sectionVisibility === ALLOCATOR;
    const confidentialText = (
      <div>
        <h5>This Information is Confidential</h5>
        <p>
          Information in this section is only available to approved asset allocators. Email{' '}
          <strong>
            <a href="mailto:access@sumzero.com">access@sumzero.com</a>
          </strong>{' '}
          to learn more.
        </p>
      </div>
    );

    return (
      <div ref={el => (this.el = el)}>
        <FundProfileSectionHeader
          icon={icon}
          title={title}
          tip={tip}
          section={section}
          sectionVisibility={sectionVisibility}
          sectionCompletenessPercent={sectionCompletenessPercent}
          sectionExcluded={sectionExcluded}
          openEditModal={editForm && this.openEditModal}
          openReorderModal={reorderForm && !sectionEmpty && this.openReorderModal}
          roleIsAdmin={roleIsAdmin}
          openBlocklistModal={openBlocklistModal}
          fundProfileId={fundProfileId}
        />
        {roleIsAdmin && editForm && (
          <FundProfileFormModalContainer
            isOpen={this.state.editModalOpen}
            closeModal={this.closeModal}
            modalId={`edit_form_${section}`}
            icon={icon}
            title={title}
            alertText={editFormBoxText}
            form={editForm}
            fundProfile={fundProfile}
            validationSchema={validationSchema}
            update={updateSection}
          />
        )}
        {roleIsAdmin && reorderForm && !sectionEmpty && (
          <FundProfileFormModalContainer
            isOpen={this.state.reorderModalOpen}
            closeModal={this.closeModal}
            modalId={`reorder_form_${section}`}
            icon={icon}
            title={title}
            alertText={reorderFormBoxText}
            form={reorderForm}
            fundProfile={fundProfile}
            validationSchema={validationSchema}
            update={updateSection}
          />
        )}
        {sectionEmpty && roleIsAdmin && <AlertStatic>{emptyText}</AlertStatic>}
        {sectionConfidential && <AlertStatic>{confidentialText}</AlertStatic>}
        {!sectionEmpty && !sectionConfidential && (
          <Component
            fundProfile={fundProfile}
            createAuditRecord={createAuditRecord}
            showUserDetails={showUserDetails}
            shrink={Boolean(shrink)}
            roleIsAdmin={roleIsAdmin}
          />
        )}
      </div>
    );
  }
}

export default FundProfileSection;
